import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// 用来存储数据
const state = {
	token: localStorage.getItem('token') || '', //登录token
	isMobile: localStorage.getItem('isMobile') || false, //是否是手机端
	lang: localStorage.getItem('lang') || 'CN', //CHS选择语言,传给后端的
	ilang: localStorage.getItem('ilang') || 'zh', //选择语言，本地语言
	userInfo: localStorage.getItem('userInfo') || {}, //用户信息
	link: localStorage.getItem('link') || '', //客服链接
	pagelink: localStorage.getItem('link') || '', //客服链接
	version: localStorage.getItem('version') || '1.0.0', //绑定号
	darkmode: localStorage.getItem('darkmode') || false, //黑白模式 ，true 黑
	TXparams: localStorage.getItem('TXparams') || null, //提现参数 返回上一页获取
	Config: localStorage.getItem('Config') || null, //系统配置
	CacheList: localStorage.getItem('CacheList') || [], //下载的视频列表
	points: localStorage.getItem('points') || 0, //是否开启app应用锁
	isHideVideo: localStorage.getItem('isHideVideo') || true, //是否隐藏关于视频内容
	NoticesList: localStorage.getItem('NoticesList') || [], //系统消息阅读状态列表
	loginInfo: localStorage.getItem('loginInfo') || null, //登录信息记住账号
	TimeZone:localStorage.getItem('TimeZone') ||"",
	dropidx:localStorage.getItem('dropidx') ||-1,
	islookpop:localStorage.getItem('islookpop') || false, //是否查看首页公共弹窗 ，true 已看
}
// 响应组件中的事件
const actions = {

}
// 操作数据
const mutations = {
	setUserInfo(state, userInfo) {
		localStorage.setItem('userInfo', userInfo)
		state.userInfo = userInfo
	},
	setToken(state, token) {
		localStorage.setItem('token', token)
		state.token = token
	},
	setLang(state, lang) {
		localStorage.setItem('lang', lang)
		state.lang = lang
	},
	setIlang(state, ilang) {
		localStorage.setItem('ilang', ilang)
		state.ilang = ilang
	},
	setLink(state, link) {
		localStorage.setItem('link', link)
		state.link = link;
	},
	setpageLink(state, link) {
		localStorage.setItem('pagelink', link)
		state.pagelink = link;
	},
	setVersion(state, version) {
		localStorage.setItem('version', version)
		state.version = version;
	},
	setConfig(state, Config) {
		localStorage.setItem('Config', Config)
		state.Config = Config;
	},
	setLoginOut(state) {
		state.token = '';
		state.userInfo = {};
		localStorage.setItem('token', '')
		localStorage.setItem('userInfo', {})
		localStorage.setItem('islookpop',false)
		state.islookpop =false;
	},
	setDarkmode(state, darkmode) {
		localStorage.setItem('darkmode', darkmode)
		state.darkmode = darkmode;
	},
	setTXparams(state, TXparams) {
		localStorage.setItem('TXparams', TXparams)
		state.TXparams = TXparams;
	},
	setCacheList(state, CacheList) {
		localStorage.setItem('CacheList', CacheList)
		state.CacheList = CacheList;
	},
	setpoints(state, points) {
		localStorage.setItem('points', points)
		state.points = points;
	},
	setHideVideo(state, isHideVideo) {
		localStorage.setItem('isHideVideo', isHideVideo)
		state.isHideVideo = isHideVideo;
	},
	setNoticesList(state, NoticesList) {
		localStorage.setItem('NoticesList', NoticesList)
		state.NoticesList = NoticesList;
	},
	setisMobile(state, isMobile) {
		localStorage.setItem('isMobile', isMobile)
		state.isMobile = isMobile;
	},
	setLoginInfo(state, loginInfo) {
		localStorage.setItem('loginInfo', loginInfo)
		state.loginInfo = loginInfo
	},
	//缓存上时区
	setTimeZone(state, data) {
		state.TimeZone = data
		localStorage.setItem('TimeZone',data)
	},
	//缓存上时区索引
	setDropidx(state, data) {
		state.dropidx = data
		localStorage.setItem('dropidx',data)
	},
	setIslookpop(state, islookpop) {
		localStorage.setItem('islookpop', islookpop)
		state.islookpop = islookpop;
	},
}
// 用来将state数据进行加工
const getters = {
	getUserInfo: state => state.userInfo,
	getToken: state => state.token,
	getLang: state => state.lang,
}
// 新建并暴露store
export default new Vuex.Store({
	state: localStorage.getItem('state') ? JSON.parse(localStorage.getItem('state')) : state,
	actions,
	mutations,
	getters
})


// WEBPACK FOOTER //
// ./src/store/index.js